import LocalDataHandler from "@/utils/handlers/LocalDataHandler";

export const getters = {
  /** Menu**/
  getSelectedMenuItem(state) {
    if (LocalDataHandler.getMenuItem() !== null)
      state.selectedMenuItem = LocalDataHandler.getMenuItem();
    return state.selectedMenuItem;
  },

};
